import { component } from 'picoapp'
import jQuery from 'jquery'

export default component((node, ctx) => {
  
    jQuery('.js-color').click(function() {
        node.classList.remove('sizes-open');
        node.classList.toggle('colors-open');
    });

    jQuery('.js-size').click(function() {
        node.classList.remove('colors-open');
        node.classList.toggle('sizes-open');
    });

    const options = JSON.parse(document.querySelector('.js-options').innerHTML).options;

    jQuery('input[type=radio][name=Color]').change(function() {
        document.querySelector('.js-color-option').dataset.bg = this.value;
        // document.querySelector('.js-color-option').classList.remove('pulsing');
        node.classList.remove('colors-open');

        jQuery('.label-size').hide();
        jQuery('.radio-size').prop('checked', false);
        let val = this.value
        jQuery('.js-selected-color').html(val);

        for (let option of options[this.value].sizes) {
            jQuery('.label[data-color="' + option + '"]').show();
        }

        
    });

    jQuery('input[type=radio][name=Size]').change(function() {

        let v = this.value.charAt(0);

        document.querySelector('.js-size-option').classList.remove('growing');

        if (this.value == 'Individual') {
            v = '1'
        }

        if (this.value == 'Set of 2') {
            v = '2'
        }

        if (this.value == 'Set of 3') {
            v = '3'
        }

        if (this.value == 'Set of 4') {
            v = '4'
        }

        if (this.value == 'Set of 6') {
            v = '6'
        }

        if (this.value == 'Set of 8') {
            v = '8'
        }

        if (this.value == 'Set of 12') {
            v = '12'
        }

        if (this.value == 'Set of 18') {
            v = '18'
        }

        if (this.value == '12 Smalls') {
            v = '12'
        }

        
        jQuery('.js-ff-size-toggle').removeClass('active')

        document.querySelector('.js-size-option').innerHTML = v;
        node.classList.remove('sizes-open');
    });

})
